import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// IMPORTACION HERRAMIENTAS GLOBALES

//Iconos geodir
import './assets/font/geodir-icon.css'

//element ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

//vuesax
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css' //Vuesax styles
Vue.use(Vuesax)

//iconos material
import 'material-icons/iconfont/material-icons.css';

import 'amcharts3'
import 'amcharts3/amcharts/pie'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
